const benefics = [
    {
        title: 'Despachos gratis en Jumbo*', 
        subtitle: 'Despachos ilimitados gratis por compras sobre $30.000 en Jumbo.cl y Jumbo App.', 
        menssage: 'Aplica sólo en zonas de cobertura (zonas urbanas).'
    },
    {
        title: 'Doble acumulación de Puntos Cencosud', 
        subtitle: 'Acumula el doble de puntos Cencosud en todas tus compras en Jumbo, Jumbo.cl y Jumbo App.',
        menssage: ''
    },
    {
        title: 'Ofertas exclusivas', 
        subtitle: 'Accede a ofertas exclusivas en Jumbo, Jumbo.cl y Jumbo App.', 
        menssage: ''
    },
    {
        title: 'Canal personalizado de atención.', 
        subtitle: 'Accede a una atención personalizada a través de tu portal de usuario Prime (sección Ayuda Prime) y Whatsapp.', 
        menssage: ''
    },
    {
        title: 'Descuento en Copec todas las semanas', 
        subtitle: 'Descuento de $15 por litro en Copec pagando con tu <strong>App Muevo.</strong>', 
        menssage: ''
    }
]

export default benefics;